import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BoardType } from 'src/app/core/models/board-type.model';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardTypeService } from 'src/app/core/services/board-type.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-board',
  templateUrl: './boardType.component.html',
  styleUrls: ['./boardType.component.scss']
})

/**
 * Dashboard Component
 */
export class BoardTypeComponent implements OnInit {
  term: any;
  boardType: any[];

  addEditMode: any;
  boardTypeFormGroup: FormGroup;


  constructor(
    private boardTypeService: BoardTypeService, 
    private modalService: NgbModal,
    private router: Router
  ) { }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Board Type', active: true }];
    await this.refresh();
  }

  async refresh() {
    
    this.boardType = await this.boardTypeService.getAll();
  

    console.log("refresh called", this)
  }

  backToBoards() {
    this.router.navigate(['/boards'])
  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.boardTypeFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),


    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, saleRepAddEditFormGroup: this.boardTypeFormGroup.value});
      if(results=="Save click") {
        const newBoardType = await this.boardTypeService.create(this.boardTypeFormGroup.value);
        if(newBoardType != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(modal: unknown, original: BoardType) {
    this.addEditMode = "Edit";
    this.boardTypeFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.boardTypeFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.boardTypeService.update(original.id, this.boardTypeFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  } 

  async onDelete( id: string) {
    await this.boardTypeService.delete(id);
    await this.refresh();     
  } 
}
